import {
  FaSpotify,
  FaTwitter,
  FaInstagram,
  FaTiktok,
  FaYoutube,
  FaApple,
} from 'react-icons/fa'

const socialMediaLinksData = [
  {
    name: 'TikTok',
    url: 'https://www.tiktok.com/@janette.king',
    icon: <FaTiktok size={24} />,
  },
  {
    name: 'Instagram',
    url: 'https://instagram.com',
    icon: <FaInstagram size={24} />,
  },
  {
    name: 'Spotify',
    url: 'https://https://open.spotify.com/artist/77KRcsLbRizUbGjctloC8a.com',
    icon: <FaSpotify size={24} />,
  },

  {
    name: 'YouTube',
    url: 'https://www.youtube.com/channel/UClNIy5lt1N3aVY64Z0YeQzw',
    icon: <FaYoutube size={24} />,
  },
  {
    name: 'Apple Music',
    url: 'https://music.apple.com/ca/artist/janette-king/906547894',
    icon: <FaApple size={24} />,
  },
  {
    name: 'Twitter',
    url: 'https://twitter.com',
    icon: <FaTwitter size={24} />,
  },
]

export default socialMediaLinksData
